var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWidtdrawDeposit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3786 0.5H2.17143C1.24832 0.5 0.5 1.22694 0.5 2.12368V13.0835C0.5 13.9802 1.24832 14.7071 2.17143 14.7071H16.3786C17.3017 14.7071 18.05 13.9802 18.05 13.0835V2.12368C18.05 1.22694 17.3017 0.5 16.3786 0.5Z",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.88465 8.02151C3.65388 8.02151 3.4668 7.83442 3.4668 7.60365C3.4668 7.37287 3.65388 7.18579 3.88465 7.18579",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.88477 8.02151C4.11554 8.02151 4.30262 7.83442 4.30262 7.60365C4.30262 7.37287 4.11554 7.18579 3.88477 7.18579",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6659 8.02151C14.4351 8.02151 14.248 7.83442 14.248 7.60365C14.248 7.37287 14.4351 7.18579 14.6659 7.18579",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.666 8.02151C14.8968 8.02151 15.0839 7.83442 15.0839 7.60365C15.0839 7.37287 14.8968 7.18579 14.666 7.18579",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27483 9.69298C10.4287 9.69298 11.3641 8.75758 11.3641 7.60369C11.3641 6.4498 10.4287 5.5144 9.27483 5.5144C8.12094 5.5144 7.18555 6.4498 7.18555 7.60369C7.18555 8.75758 8.12094 9.69298 9.27483 9.69298Z",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.51367 18.8858H20.5565C20.9998 18.8858 21.425 18.7096 21.7384 18.3963C22.0518 18.0829 22.228 17.6576 22.228 17.2144V6.3501",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidtdrawDeposit);
export default __webpack_public_path__ + "static/media/widtdrawDeposit.39a99af4701e5e9ece8cfb97f106eba4.svg";
export { ForwardRef as ReactComponent };